const esLocale = {
	title: 'Acción requerida',
	subtitle:
		'Por favor, actualice la información de contacto principal del <span id="cp-font-semibold">propietario/facturación</span> de su negocio a continuación.',

	'labels.firstname': 'Primer nombre *',
	'labels.lastname': 'Apellido *',
	'labels.emailaddress': 'Dirección de correo electrónico *',
	'labels.country': 'País de los negocios *',
	'labels.phonenumber': 'Número de teléfono de la empresa *',
	'labels.streetaddress': 'Dirección de la empresa *',
	'labels.city': 'Ciudad *',
	'labels.stateprovince': 'Estado/Provincia *',
	'labels.zippostalcode': 'Código postal *',

	'buttons.skip': 'Saltar',
	'buttons.update': 'Actualizar e iniciar sesión',

	'errors.empty.firstname': 'El nombre es obligatorio.',
	'errors.empty.lastname': 'El apellido es obligatorio.',
	'errors.empty.emailaddress':
		'La dirección de correo electrónico es obligatoria.',
	'errors.invalid.emailaddress':
		'Por favor, introduzca una dirección de correo electrónico válida.',
	'errors.empty.country': 'El país es necesario.',
	'errors.empty.phonenumber': 'El número de teléfono es obligatorio.',
	'errors.invalid.phonenumber':
		'El número de teléfono debe contener al menos 2 dígitos.',
	'errors.empty.streetaddress': 'Se requiere la dirección de la calle.',
	'errors.empty.city': 'La ciudad es necesaria.',
	'errors.empty.stateprovince': 'Se requiere el estado/provincia.',
	'errors.empty.zippostalcode': 'Se requiere el código postal.',
	'errors.invalid.zippostalcode':
		'El código postal debe contener al menos 2 dígitos.',
};

export default esLocale;
